import { render, staticRenderFns } from "./faceLog.vue?vue&type=template&id=1dc34e76&scoped=true&"
import script from "./faceLog.vue?vue&type=script&lang=js&"
export * from "./faceLog.vue?vue&type=script&lang=js&"
import style0 from "./faceLog.vue?vue&type=style&index=0&id=1dc34e76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc34e76",
  null
  
)

export default component.exports